import { drilldownDataCorporate, ModuleFields } from "~/Utils/drilldownDataDum";

export const mapFields = (data: ModuleFields[]) => {
  return data.map(({ fieldName, placeholder, name, formType, validation, className, hidden, usedFileType }) => ({
    name,
    type: formType,
    label: fieldName,
    placeholder,
    validation,
    className,
    hidden,
    usedFileType
  }));
};

let fields: any = {};

const fieldsReady = new Promise(async (resolve, reject) => {
  try {
    const data = await drilldownDataCorporate();
    fields = {
      commercialLeasingOpportunities: data?.commercialLeasingOpportunities?.map((data: ModuleFields[]) => {
        return mapFields(data);
      }),
      commercialLeasingOpportunitiesNextPage: mapFields(data?.commercialLeasingOpportunitiesNextPage),
      commercialLeasingOpportunitiesMainContent: mapFields(data?.commercialLeasingOpportunitiesMainContent),
      commercialLeasingOpportunitiesFormValues: mapFields(data?.commercialLeasingOpportunitiesFormValues)
    };
    console.log("constantsdum-commerical", fields);
    resolve(fields); 
  } catch (error) {
    console.error("Error accessing drilldown data:", error);
    reject(error); 
  }
});

export { fields, fieldsReady };
